import { DashboardResources } from '@src/types';

import RepairPricingEdit from './RepairPricingEdit';
import RepairPricingList from './RepairPricingList';

export { repairPricingDataProvider } from './dataProvider';

export default {
  name: DashboardResources.RepairPricing,
  list: RepairPricingList,
  edit: RepairPricingEdit,
  options: { label: 'Repair Pricing' },
};
